import { action } from '../lib/actionHelpers.js';
import apiRequests from '../lib/apiRequests.js';
import { getAppSettings } from '../redux/actions/appActions.js';
import { getServiceProvider } from '../redux/actions/serviceProviderActions.js';
import selectors from '../selectors/selectors.js';
import { useEffect } from 'react';
import { useLocation } from 'react-router';
import { useParams } from 'react-router-dom';
import { usePrevProps } from '../hooks/index.js';
import { useSelector } from 'react-redux';

const AppStateHandler = ({ isProtected, fixedWidth = false }) => {
  const location = useLocation();
  const match = useParams();

  const loggedIn = useSelector((state) => state.user.loggedIn);
  const lastSettingsLoad = new Date(useSelector((state) => state.app.lastSettingsLoad) || '1 Jan 1970');
  const userServiceProviderIds = useSelector(selectors.userServiceProviderIds);
  const isFixedWidth = useSelector((state) => state.ui.fixedWidth);
  const matchedServiceProviderId = match.serviceProviderId;
  const prevServiceProviderId = usePrevProps(matchedServiceProviderId);  
  const matchedServiceProviderIdIsValid = matchedServiceProviderId && userServiceProviderIds.includes(matchedServiceProviderId);
  const timeSinceLastSettingsLoad = new Date() - lastSettingsLoad;

  useEffect(() => {
    if (matchedServiceProviderIdIsValid && loggedIn && isProtected) {      
      if (prevServiceProviderId) {
        action('RESET_TO_INITIAL_STATE');
      }
      if (prevServiceProviderId || (matchedServiceProviderId && timeSinceLastSettingsLoad > 1000 * 60 * 60 * 24)) {
        getAppSettings();
      }
      getServiceProvider(matchedServiceProviderId);
    }
  }, [matchedServiceProviderId, isProtected, loggedIn]);
  
  useEffect(() => {
    apiRequests.cancelByPathname(location.pathname);
  }, [location.pathname]);

  useEffect(() => {
    if (fixedWidth !== isFixedWidth) {
      action('uiSetFixedWidth', fixedWidth);
    }
  }, [fixedWidth]);

  return null;
};

export default AppStateHandler;
